/**
 * @desc getResource
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.LoginExchangeDto, options?: any) {
  return updateResponse(
    http(URL + `/load/resource`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
